import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/zh-cn'
import App from './App'
import { EnvProvider } from './providers/EnvProvider'
import './styles/globals.css'

// 配置 dayjs 插件
dayjs.extend(utc)
dayjs.locale('zh-cn')

// 发版后旧标签页会引用被新构建删除的 hash chunk,懒加载路由时 Vite 抛 vite:preloadError
// (表现:MIME "text/html" / Failed to fetch dynamically imported module → 白屏)。
// 自动整页刷新一次拉取新 index.html + 当前 hash 的 chunk;10s 时间窗防刷新死循环(真坏了不会无限刷)。
window.addEventListener('vite:preloadError', () => {
  const KEY = '__preload_reload_ts__'
  const last = Number(sessionStorage.getItem(KEY) || 0)
  if (Date.now() - last < 10000) return
  sessionStorage.setItem(KEY, String(Date.now()))
  window.location.reload()
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider locale={zhCN}>
        <EnvProvider>
          <App />
        </EnvProvider>
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
)
